import ReactDOM from "react-dom";
import { Container } from "./firstLookContainer.js";
import "../../../../shared/styles/colorDefinitions.css";
import "../../style.css";
import "../../../../shared/styles/buttonStyles.css";
import "../../../../shared/styles/linkStyles.css";
import React from "react";
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(React.createElement(Container, null), document.body.querySelector("#container"));
